import Model from '@/store/model';

class FillTheGapTestOption extends Model {
  map(json) {
    super.map(json);

    if (json.gap_id) {
      this.gapId = parseInt(json.gap_id, 10);
    }

    if (json.alternative_answers) {
      this.alternativeAnswers = json.alternative_answers;
    }
  }
}

export default FillTheGapTestOption;
